/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, answerError } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : CONTENT : STORY : STYLES --------------- ++++++++++ */
export default {
    emailcollection: {
        '& .structureinner': {
            zIndex: 2,
            '& .editable': {
                width: '100%',
                position: 'relative',
                '& .editabletextwrapper': {
                    textAlign: 'left'
                },
                '&.editableheadline': {
                    marginTop: pxToEm(12),
                    '& .editabletextwrapper': {
                        fontSize: pxToEm(24)
                    }
                },
                '&.editablebody': {
                    marginTop: pxToEm(18),
                    '& .editabletextwrapper': {
                        fontSize: pxToEm(14)
                    }
                },
                '&.valid-false': {
                    extend: answerError.text
                }
            },
            '& .useremail': {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                padding: pxToEm(8),
                margin: `${pxToEm(24)} 0`,
                background: 'rgba(0, 0, 0, 0.2)',
                borderRadius: pxToEm(3),
                height: pxToEm(32),
                width: '100%',
                maxWidth: pxToEm(280),
                color: 'rgb(255, 255, 255, 0.4)',
                fontSize: pxToEm(14),
                fontWeight: 500,
            },
            '& .callouttext': {
                fontSize: pxToEm(12),
                fontWeight: 500,
                width: '100%',
                textAlign: 'left',
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
                '&.insticator': {
                    marginBottom: pxToEm(8)
                }
            }
        },
        '& .imageindicator':{
            display: 'none'
        },
        '& .removeimageindicator': {
            display: 'flex !important',
            bottom: `${pxToEm(10)} !important`,
            left: `${pxToEm(10)} !important`
        }
    }
};
